// extracted by mini-css-extract-plugin
module.exports = {"BaseLayout":"BaseLayout_BaseLayout__3Ayog","BaseLayout__Footer":"BaseLayout_BaseLayout__Footer__16lWR"};